"use client";

import { createContext, useContext } from "react";

import { SHARED_TWIN_CLOCK, type TwinSequenceClock } from "./sequence";

/**
 * The clock a stage's instrument, arrival layer and riser read. Without a
 * provider they share the site's looping clock; a stage that plays the
 * sequence once (the home hero) provides its own.
 */
const TwinClockContext = createContext<TwinSequenceClock>(SHARED_TWIN_CLOCK);

export const TwinClockProvider = TwinClockContext.Provider;

export function useTwinClock(): TwinSequenceClock {
  return useContext(TwinClockContext);
}
